import React, { useEffect, useState } from 'react';
import { Card, Skeleton } from 'antd';
import useAuthContext from '../../contexts/AuthContext';
import useErrorMessage from '../../utils/ErrorMessage';

const InfoCardLeft = () => {
  const { dispatchAPI, user } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const { message } = useErrorMessage();
  const [marketingMessage, setMarketingMessage] = useState();

  const getMessage = async () => {
    setIsLoading(true);
    try {
      const {
        data: [m]
      } = await dispatchAPI('GET', {
        url: `settings?label=KNOW_MORE${
          user.role === 'guests:GUEST' ? '_USER' : ''
        }`
      });
      setMarketingMessage(m?.value);
    } catch (e) {
      message(e);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    (async () => {
      await getMessage();
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Card
        title="En savoir plus"
        className="info-card-right-home background-card"
      >
        <Skeleton loading={isLoading} className="know-more-skeleton">
          <p>{marketingMessage}</p>
        </Skeleton>
      </Card>
      <style jsx="true">
        {`
          .know-more-skeleton h3,
          .know-more-skeleton ul > li {
            background: var(--bodyBackground) !important;
          }
        `}
      </style>
    </>
  );
};

const InfoCardRight = () => {
  const { dispatchAPI, user } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const { message } = useErrorMessage();
  const [marketingMessage, setMarketingMessage] = useState();
  const getMessage = async () => {
    setIsLoading(true);
    try {
      const {
        data: [m]
      } = await dispatchAPI('GET', {
        url: `settings?label=INFORMATION${
          user.role === 'guests:GUEST' ? '_USER' : ''
        }`
      });
      setMarketingMessage(m?.value);
    } catch (e) {
      message(e);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    (async () => {
      await getMessage();
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <Card title="Informations" className="info-card-right-home">
      <Skeleton loading={isLoading}>
        <p>{marketingMessage}</p>
      </Skeleton>
    </Card>
  );
};

export { InfoCardLeft, InfoCardRight };
